import { createCrudSlice } from '@crm/features/crudSliceFactory';

const module = createCrudSlice({
  name: 'crmDirections',
  path: 'directions',
  singleKey: 'direction',
});

export const directionsActions = module.actions;
export const directionsThunks = module.thunks;
export const directionsSelectors = module.selectors;
export default module.reducer;
